export default __webpack_public_path__ + "static/media/151-real-estate-6.e0097774.png";